<div class="create-sales-order-modal">
  <form class="create-sales-order-modal__form" [formGroup]="form" (ngSubmit)="submitForm()">
    <div class="create-sales-order-modal__scroll-area">
    <section class="create-sales-order-modal__panel">
      <div class="create-sales-order-modal__grid">
        <div class="create-sales-order-modal__field md:col-span-2">
          <label class="form-label" for="sales-order-client">
            {{ 'COMPONENTS.SALES_ORDERS.FIELDS.CLIENT' | translate }}
          </label>
          <app-search
            id="sales-order-client"
            customClass="form-search-input"
            formControlName="clientId"
            [items]="(clientOptions$ | async) ?? []"
            [filterFn]="clientFilterFn"
            [formatter]="clientFormatter"
            [compareFn]="clientCompareFn"
            [placeholderText]="'COMPONENTS.SALES_ORDERS.PLACEHOLDERS.CLIENT' | translate"
            [errorMessage]="'COMPONENTS.SALES_ORDERS.ERRORS.INVALID_CLIENT' | translate"
            [resultTemplate]="clientOptionTemplate"
          ></app-search>

          <ng-template #clientOptionTemplate let-r="result" let-t="term">
            @if (r) {
              <div class="create-sales-order-modal__client-option">
                <span
                  class="create-sales-order-modal__client-badge"
                  [class.create-sales-order-modal__client-badge--organization]="r.type === 'organization'"
                  [class.create-sales-order-modal__client-badge--contact]="r.type === 'contact'"
                >
                  {{ r.typeLabelKey | translate }}
                </span>

                <div class="create-sales-order-modal__client-text">
                  <ngb-highlight
                    class="create-sales-order-modal__client-title"
                    highlightClass="hover-highlight"
                    [result]="r.title"
                    [term]="t"
                  ></ngb-highlight>
                  @if (r.subtitle) {
                    <ngb-highlight
                      class="create-sales-order-modal__client-subtitle"
                      highlightClass="hover-highlight"
                      [result]="r.subtitle"
                      [term]="t"
                    ></ngb-highlight>
                  }
                </div>
              </div>
            }
          </ng-template>
        </div>

        <div class="create-sales-order-modal__field md:col-span-2">
          @let shortDescriptionControl = form.controls.shortDescription;
          @let shortDescriptionInteracted = shortDescriptionControl.dirty || shortDescriptionControl.touched;
          <label class="form-label" for="sales-order-short-description">
            {{ 'COMPONENTS.SALES_ORDERS.FIELDS.SHORT_DESCRIPTION' | translate }}
          </label>
          <textarea
            id="sales-order-short-description"
            rows="2"
            maxlength="512"
            class="form-input form-textarea"
            [class.is-invalid]="shortDescriptionInteracted && shortDescriptionControl.errors"
            [placeholder]="'COMPONENTS.SALES_ORDERS.PLACEHOLDERS.SHORT_DESCRIPTION' | translate"
            [formControlName]="formModel.fieldNames.shortDescription"
          ></textarea>
          @if (shortDescriptionInteracted && shortDescriptionControl.errors?.['maxlength']) {
            <p class="invalid-feedback">
              {{ 'COMPONENTS.SALES_ORDERS.ERRORS.SHORT_DESCRIPTION_TOO_LONG' | translate }}
            </p>
          }
        </div>

        <div class="create-sales-order-modal__field md:col-span-2">
          <label class="form-label" for="sales-order-requested-delivery-date">
            {{ 'COMPONENTS.SALES_ORDERS.FIELDS.REQUESTED_DELIVERY_DATE' | translate }}
          </label>
          <input
            id="sales-order-requested-delivery-date"
            type="date"
            class="form-input"
            formControlName="requestedDeliveryDate"
          />
        </div>
      </div>
    </section>

    <section class="create-sales-order-modal__panel create-sales-order-modal__panel--lines">
      <div class="create-sales-order-modal__lines-header">
        <p class="create-sales-order-modal__section-hint">
          {{ 'COMPONENTS.SALES_ORDERS.CREATE_LINES_HINT' | translate }}
        </p>

        <button type="button" class="create-sales-order-modal__add-button" (click)="addLine()">
          + {{ 'COMPONENTS.SALES_ORDERS.BUTTONS.ADD_LINE' | translate }}
        </button>
      </div>

      @if (lineForms.length > 0) {
        <div class="create-sales-order-modal__lines" formArrayName="lines">
          @for (lineForm of lineForms.controls; track lineForm; let lineIndex = $index) {
            <article class="create-sales-order-modal__line" [formGroupName]="lineIndex">
              <div class="create-sales-order-modal__line-header">
                <span class="create-sales-order-modal__line-index">
                  {{ 'COMPONENTS.SALES_ORDERS.LINES.LINE_NUMBER' | translate }} {{ lineIndex + 1 }}
                </span>
                <button
                  type="button"
                  class="create-sales-order-modal__line-remove"
                  (click)="removeLine(lineIndex)"
                >
                  {{ 'BUTTONS.REMOVE' | translate }}
                </button>
              </div>

              <div class="create-sales-order-modal__line-grid">
                <div class="create-sales-order-modal__field create-sales-order-modal__field--wide">
                  <label class="form-label">
                    {{ 'COMPONENTS.SALES_ORDERS.FIELDS.INVENTORY_ITEM' | translate }}
                  </label>
                  <app-search
                    customClass="form-search-input"
                    formControlName="inventoryItemId"
                    [items]="(inventoryItemOptions$ | async) ?? []"
                    [filterFn]="inventoryItemFilterFn"
                    [formatter]="inventoryItemFormatter"
                    [compareFn]="inventoryItemCompareFn"
                    [placeholderText]="'COMPONENTS.SALES_ORDERS.PLACEHOLDERS.INVENTORY_ITEM' | translate"
                    [errorMessage]="'COMPONENTS.SALES_ORDERS.ERRORS.INVALID_INVENTORY_ITEM' | translate"
                    [resultTemplate]="inventoryItemOptionTemplate"
                  ></app-search>

                  <ng-template #inventoryItemOptionTemplate let-r="result" let-t="term">
                    @if (r) {
                      <div class="create-sales-order-modal__client-option">
                        <div class="create-sales-order-modal__client-text">
                          <ngb-highlight
                            class="create-sales-order-modal__client-title"
                            highlightClass="hover-highlight"
                            [result]="r.title"
                            [term]="t"
                          ></ngb-highlight>
                          @if (r.subtitle) {
                            <ngb-highlight
                              class="create-sales-order-modal__client-subtitle"
                              highlightClass="hover-highlight"
                              [result]="r.subtitle"
                              [term]="t"
                            ></ngb-highlight>
                          }
                        </div>
                      </div>
                    }
                  </ng-template>
                </div>

                <div class="create-sales-order-modal__field create-sales-order-modal__field--wide">
                  <label class="form-label">
                    {{ 'COMPONENTS.SALES_ORDERS.FIELDS.DESCRIPTION' | translate }}
                  </label>
                  <input type="text" class="form-input" formControlName="description" />
                </div>

                <div class="create-sales-order-modal__field create-sales-order-modal__field--wide">
                  <label class="form-label">
                    {{ 'COMPONENTS.SALES_ORDERS.FIELDS.DESCRIPTION_2' | translate }}
                  </label>
                  <input type="text" class="form-input" formControlName="description2" />
                </div>

                <div class="create-sales-order-modal__field">
                  <label class="form-label">
                    {{ 'COMPONENTS.SALES_ORDERS.FIELDS.QUANTITY' | translate }}
                  </label>
                  <input type="number" min="0.0001" step="0.0001" class="form-input" formControlName="quantity" />
                </div>

                <div class="create-sales-order-modal__field">
                  <label class="form-label">
                    {{ 'COMPONENTS.SALES_ORDERS.FIELDS.UNIT_OF_MEASURE' | translate }}
                  </label>
                  <select class="form-input" formControlName="unitOfMeasureId">
                    <option [ngValue]="null">
                      {{ 'COMPONENTS.SALES_ORDERS.PLACEHOLDERS.UNIT_OF_MEASURE' | translate }}
                    </option>
                    @if (lineViews$ | async; as lineViews) {
                      @for (uom of lineViews[lineIndex]?.unitOptions; track uom.unitOfMeasureId) {
                        <option [ngValue]="uom.unitOfMeasureId">
                          {{ uom.displayName }}
                          @if (uom.isBase) {
                            ({{ 'COMPONENTS.SALES_ORDERS.FIELDS.BASE_UNIT_BADGE' | translate }})
                          }
                        </option>
                      }
                    }
                  </select>
                </div>

                <div class="create-sales-order-modal__field">
                  <label class="form-label">
                    {{ 'COMPONENTS.SALES_ORDERS.FIELDS.UNIT_PRICE' | translate }}
                  </label>
                  <input type="number" min="0" step="0.0001" class="form-input" formControlName="unitPrice" />
                </div>

                <div class="create-sales-order-modal__field">
                  <label class="form-label">
                    {{ 'COMPONENTS.SALES_ORDERS.FIELDS.TAX_PERCENT' | translate }}
                  </label>
                  <input type="number" min="0" step="0.0001" class="form-input" formControlName="taxPercent" />
                </div>

                <div class="create-sales-order-modal__field">
                  <label class="form-label">
                    {{ 'COMPONENTS.SALES_ORDERS.LINES.CURRENCY' | translate }}
                  </label>
                  <select class="form-input" formControlName="currencyCode">
                    <option [ngValue]="null">{{ 'COMPONENTS.SALES_ORDERS.LINES.CURRENCY_PLACEHOLDER' | translate }}</option>
                    @for (currency of currencyOptions; track currency) {
                      <option [ngValue]="currency">{{ currency }}</option>
                    }
                  </select>
                </div>
              </div>

              @if (lineViews$ | async; as lineViews) {
                @if (lineViews[lineIndex]; as totals) {
                  <dl class="create-sales-order-modal__line-totals">
                    <div>
                      <dt>{{ 'COMPONENTS.SALES_ORDERS.TOTALS.NET' | translate }}</dt>
                      <dd>{{ totals.amountExcludingTax | number: '1.2-2' }}</dd>
                    </div>
                    <div>
                      <dt>{{ 'COMPONENTS.SALES_ORDERS.TOTALS.TAX' | translate }}</dt>
                      <dd>{{ totals.totalTaxAmount | number: '1.2-2' }}</dd>
                    </div>
                    <div>
                      <dt>{{ 'COMPONENTS.SALES_ORDERS.TOTALS.TOTAL' | translate }}</dt>
                      <dd>{{ totals.amountIncludingTax | number: '1.2-2' }}</dd>
                    </div>
                  </dl>
                }
              }
            </article>
          }
        </div>

        @if (totalsView$ | async; as totalsView) {
          <dl class="create-sales-order-modal__totals">
            <div>
              <dt>{{ 'COMPONENTS.SALES_ORDERS.TOTALS.NET' | translate }}</dt>
              <dd>{{ totalsView.amountExcludingTax | number: '1.2-2' }}</dd>
            </div>
            <div>
              <dt>{{ 'COMPONENTS.SALES_ORDERS.TOTALS.TAX' | translate }}</dt>
              <dd>{{ totalsView.totalTaxAmount | number: '1.2-2' }}</dd>
            </div>
            <div class="create-sales-order-modal__totals-grand">
              <dt>{{ 'COMPONENTS.SALES_ORDERS.TOTALS.TOTAL' | translate }}</dt>
              <dd>{{ totalsView.amountIncludingTax | number: '1.2-2' }}</dd>
            </div>
          </dl>
        }
      }

      @if (errorMessageKey) {
        <p class="create-sales-order-modal__error">
          {{ errorMessageKey | translate }}
        </p>
      }
    </section>
    </div>

    <div class="create-project-actions create-sales-order-modal__actions">
      <button type="button" class="form-secondary-btn" (click)="onCancel()">
        {{ 'BUTTONS.CANCEL' | translate }}
      </button>

      <button type="submit" class="form-primary-btn" [disabled]="isSubmitting">
        {{ 'BUTTONS.CREATE' | translate }}
      </button>
    </div>
  </form>
</div>
